import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, SimpleGrid } from "@chakra-ui/react";
import AdmForm from "./components/Form";
import AdmTable from "./components/Table";
import useAdm from "./hooks/useAdm";
import { ConditionalRenderer } from "views/admin/components/ConditionalRenderer";
import { MdArrowBack, MdAdd } from "react-icons/md";
import { SimpleConditionalFrame } from "views/admin/components/SimpleConditionalFrame";

const ProjectManageScreen = () => {
  const {
    clients,
    contatoAgencia1,
    contatoCliente1,
    list1,
    loading,
    selectedOrder1,
    show1,
    showModal1,
    users,
    usuario,
    fornecedores,
    condicaoPagamento,
    loadOs,
    error,
    errorMsg,
    errorTitle,
    loadFornecedores,
    showError,
    osList,
    setOsList,
    saveOs,
    cancelAlertModalRef,
    modalDisclosure,
    deleteOs,
    deleteOsExec,
    setShowContaPagarModal,
    showContaPagarModal
  } = useAdm();
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }} overflowY={"hidden"}>

      <ConditionalRenderer
        conditions={[
          {
            condition: show1,
            component: (
              <SimpleConditionalFrame
                backClick={() => showModal1(false, null)}
                title="Gestão Administrativa do Projeto"
              >
                <AdmForm
                  accountSelected={selectedOrder1}
                  clients={clients}
                  contatoAgencia={contatoAgencia1}
                  contatoCliente={contatoCliente1}
                  fornecedor={fornecedores}
                  loading={loading}
                  show={show1}
                  showModal={showModal1}
                  users={users}
                  condicaoPagamento={condicaoPagamento}
                  loadOs={loadOs}
                  error={error}
                  errorMsg={errorMsg}
                  errorTitle={errorTitle}
                  loadFornecedores={loadFornecedores}
                  showError={showError}
                  osList={osList}
                  setOsList={setOsList}
                  saveOs={saveOs}
                  deleteOs={deleteOs}
                  showContaPagarModal={showContaPagarModal}
                  setShowContaPagarModal={setShowContaPagarModal}
                />
              </SimpleConditionalFrame>
            ),
          }
        ]}
        fallback={(
          <SimpleGrid
            mb="20px"
            columns={{ sm: 1, md: 1 }}
            spacing={{ base: "20px", xl: "20px" }}
          >
            <AdmTable list={list1} showModal={showModal1} />
          </SimpleGrid>
        )}
      />

      <AlertDialog
        isOpen={modalDisclosure.isOpen}
        leastDestructiveRef={cancelAlertModalRef}
        onClose={modalDisclosure.onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Remover OS?
            </AlertDialogHeader>

            <AlertDialogBody>
              Essa ação é irreversível, deseja realmente remover essa OS?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelAlertModalRef} onClick={modalDisclosure.onClose}>
                Cancelar
              </Button>
              <Button colorScheme='red' onClick={() => {
                deleteOsExec();
                modalDisclosure.onClose();
              }} ml={3}>
                Deletar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};
export default ProjectManageScreen;
